import { render, staticRenderFns } from "./MenuSave.vue?vue&type=template&id=77c17105&"
import script from "./MenuSave.vue?vue&type=script&lang=js&"
export * from "./MenuSave.vue?vue&type=script&lang=js&"
import style0 from "./MenuSave.vue?vue&type=style&index=0&id=77c17105&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports